<template>
  <el-dialog
      :visible.sync="visible"
      title="查看库存详情"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-button type="warning" size="mini" v-if="$hasPermission('erp:receipt:bind')" @click="showBindFormDialog">绑定进项发票</el-button>
    <StoreLogTable ref="StoreLogTable" :default-query-params="{sourceId:id,type:-1,queryType:queryType}" :table-height="500"
                   :show-query-bar="false" :has-page="false" :hide-columns="['boxReceiptCode','backCount','transferCount']"></StoreLogTable>
    <el-dialog
        :visible.sync="formVisible"
        title="绑定进项发票"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="600px"
        :append-to-body="true"
    >
      <el-form
          :model="dataForm"
          :rules="dataRule"
          ref="dataForm"
          label-width="120px"
      >
        <el-form-item prop="receiptCode" label="进项发票号：">
          <el-input v-model="dataForm.receiptCode" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button type="primary" size="mini" @click="dataFormSubmitHandle">确定</el-button>
        <el-button size="mini" @click="formVisible = false">取消</el-button>
      </template>
    </el-dialog>
  </el-dialog>
</template>

<script>

import StoreLogTable from '@/views/modules/erp/common/store-log-table.vue'

export default {
  name: 'BackDialog',
  components: {
    StoreLogTable
  },
  data () {
    return {
      id: '',
      visible: false,
      formVisible: false,
      queryType:'',
      dataForm: {
        receiptCode: ''
      },
      dataRule: {
        receiptCode: [
          { required: true, message: '请输入发票号', trigger: 'change' },
        ],
      }
    }
  },
  methods: {
    showBindFormDialog () {
      this.dataForm.receiptCode=''
      this.formVisible = true
      this.$nextTick(()=>{
        this.$refs.dataForm.clearValidate()
      })
    },
    init (id) {
      this.id = id
      this.visible = true
      this.$nextTick(() => {
        this.$refs.StoreLogTable.reload()
      })
    },
    async doSave () {
      let selRows = this.$refs.StoreLogTable.getSelectedRows()
      if (this.$c.isArrayEmpty(selRows)) {
        return this.$message.warning('请选择需要绑定的记录')
      }
      let loading = this.$loading()
      try {
        await this.$confirm('确定绑定进项发票吗？')
        await this.$api2.post('/erp/receipt/bind', {
          ids: selRows.map(row => row.id),
          receiptCode: this.dataForm.receiptCode
        })
        loading.close()
        this.$message.success('绑定成功')
        this.$refs.StoreLogTable.reload()
        this.formVisible = false
      } catch (e) {
        loading.close()
      }
    },
    dataFormSubmitHandle () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.doSave()
      })
    }
  }
}
</script>

<style scoped>

</style>
